import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "primereact/button";
import { HashLink as Link } from "react-router-hash-link";
import emailjs from "@emailjs/browser"
import './Landing.css';
import Stickymenu from "../../components/Stickymenu/Stickymenu";
import Story from "../../pages/Story/Story";
import Projects from "../../components/Projects/Projects";
import Pitch from "../../components/Pitch/Pitch";
import Contact from "../../components/Contact/Contact";

export default function Landing () {

    const navigate = useNavigate();

    return (
        <div className="landing-container">
            <Stickymenu />
            <div className="landing">
                <section className="sHero" id="hero">
                    <div className="name-title">
                        <h1 className="thin-text">Hello, I'm</h1>
                        <h1 className="name">Maximilian Skjønhaug</h1>
                    </div>
                    <img 
                        className="hero-img"
                        src="https://i.imgur.com/vlf3qua.png" 
                        alt="profile" />
                    <h2 className="tagline thin-text">I'm a <span className="job">Fullstack Developer</span></h2>
                    <div className="buttons-container">
                        <Link to="/#contact" className="landing-button">
                        <div className="landing-button">
                            <Button 
                                label="Lets Talk" 
                                icon="pi pi-comments" 
                                className="talk-button p-button-lg" 
                                style={{color:"white"}} 
                                />
                        </div>
                        </Link>
                        <div className="landing-button">
                            {/* make a button that downloads a pdf file from the public folder */}
                            <a href="../../public/maximilian-skjonhaug.pdf" download={true}></a>
                            <Button 
                                label="Download CV" 
                                icon="pi pi-download" 
                                className="download-button p-button p-button-secondary" 
                                download="Maximilian Skjønhaug CV.pdf"
                                />
                        </div>
                    </div>
                </section>
                <section className="section sStory" id="story">
                    <Story />
                </section>
                <section className="section sProjects" id="projects">
                    <Projects />
                </section>
                <section className="section sPitch" id="pitch">
                    <Pitch />
                </section>
                <section className="section sContact" id="contact">
                    <Contact />
                </section>
            </div>
        </div>
    )
}